export default __webpack_public_path__ + "static/media/document-img.140d9dc1.png";